import { get } from "../../security/secureClient";

export const getAllVisibilityGroups = (): Promise<any> => get("visibility-group");
